import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css';

// Suppress benign ResizeObserver loop error (browser quirk when resize triggers more resize in same frame)
if (typeof window !== 'undefined') {
  const resizeObserverLoopErr = /ResizeObserver loop completed with undelivered notifications/;
  window.addEventListener('error', (e) => {
    if (resizeObserverLoopErr.test(e.message)) {
      e.stopImmediatePropagation();
      return true;
    }
  }, true);
}

// Apply default theme before React mounts (when no theme saved in localStorage)
const savedTheme = localStorage.getItem('theme');
const themeToApply = savedTheme || 'default';
document.documentElement.setAttribute('data-theme', themeToApply);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
);